(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyManagerDialogController', CompanyManagerDialogController);

    CompanyManagerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyManager', 'Company', 'PersonInfo', 'CompanyCustom', 'PersonInfoQuery'];

    function CompanyManagerDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyManager, Company, PersonInfo, CompanyCustom, PersonInfoQuery) {
        var vm = this;

        vm.companyManager = entity;
        vm.clear = clear;
        vm.save = save;
        vm.companies = Company.query();
        vm.personinfos = PersonInfo.query();
        vm.findCompany = findCompany;
        vm.findPersonInfo = findPersonInfo;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.companyManager.id !== null) {
                CompanyManager.update(vm.companyManager, onSaveSuccess, onSaveError);
            } else {
                CompanyManager.save(vm.companyManager, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyManagerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function findCompany() {

            if (vm.companyManager.companyName != null && vm.companyManager.companyName != undefined) {
                var c = CompanyCustom.findCompanyByQuery(vm.companyManager.companyName).query();
                if (c != null && c != undefined) {
                    vm.companyManager.company = c;
                    vm.companyManager.companyId = vm.companyManager.company.id;
                }
            }

        }

        function findPersonInfo() {
            if (vm.companyManager.personInfoName != null && vm.companyManager.personInfoName != undefined) {
                var c = PersonInfoQuery.findPersonInfoByQuery(vm.companyManager.personInfoName).query();
                if (c != null && c != undefined) {
                    vm.companyManager.personInfo = c;
                    vm.companyManager.companyId = vm.companyManager.personInfo.id;
                }
            }

        }

    }
})();
